















































































import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import PeriodType from '@/models/Shared/PeriodType';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositFixedTermSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    PeriodType = PeriodType;

    @Prop( {required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositFixedTerm) {
                ProductWizardModule.createProductViewModel.depositFixedTermSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get fundingWindowTriggerTypeOptions() {
        return ListUtils.fundingWindowTriggerTypeOptions();
    }

}
